import { createAction } from 'redux-actions'
import {
  FETCH_EXPENSE_ENTITY_TAGS,
  FETCH_EXPENSE_ENTITY_TAGS_FAILED,
  FETCH_EXPENSE_ENTITY_TAGS_SUCCEEDED,
} from 'Redux/Types/EntityTypes'

export const fetchExpenseEntityTags = createAction(FETCH_EXPENSE_ENTITY_TAGS)
export const fetchExpenseEntityTagsFailed = createAction(FETCH_EXPENSE_ENTITY_TAGS_FAILED)
export const fetchExpenseEntityTagsSucceeded = createAction(FETCH_EXPENSE_ENTITY_TAGS_SUCCEEDED)
